import { IPrevAdminToolSettingsState } from '../interfaces';
export const setAdminToolSettingHandler = (
  adminToolState: string,
  setAdminToolSettings: (
    value: (prevState: IPrevAdminToolSettingsState) => {
      telephoneNumber: string;
      customerLogin: boolean;
      customerTelephoneService: boolean;
      agodaBrandLink: boolean;
      pricelineBrandLink: boolean;
      disableFields: boolean;
    }
  ) => void
) => {
  switch (adminToolState) {
    case 'disableFields': {
      setAdminToolSettings((prevState) => {
        if (prevState.disableFields) {
          return {
            telephoneNumber: prevState.telephoneNumber,
            customerLogin: false,
            customerTelephoneService: false,
            agodaBrandLink: false,
            pricelineBrandLink: false,
            disableFields: !prevState.disableFields
          };
        } else {
          return {
            ...prevState,
            disableFields: !prevState.disableFields
          };
        }
      });
      break;
    }
    case 'customerLogin': {
      setAdminToolSettings((prevState) => {
        return {
          ...prevState,
          customerLogin: !prevState.customerLogin
        };
      });
      break;
    }
    case 'customerTelephoneService': {
      setAdminToolSettings((prevState) => {
        return {
          ...prevState,
          customerTelephoneService: !prevState.customerTelephoneService
        };
      });
      break;
    }
    case 'agodaBrandLink': {
      setAdminToolSettings((prevState) => {
        return {
          ...prevState,
          agodaBrandLink: !prevState.agodaBrandLink
        };
      });
      break;
    }
    case 'pricelineBrandLink': {
      setAdminToolSettings((prevState) => {
        return {
          ...prevState,
          pricelineBrandLink: !prevState.pricelineBrandLink
        };
      });
      break;
    }
  }
};

export const adminToolStateKeyName = (toolStateKeyName: string) => {
  let stateKeyMap = '';
  switch (toolStateKeyName) {
    case 'disableFields': {
      stateKeyMap = 'Crisis Tool';
      break;
    }
    case 'customerLogin': {
      stateKeyMap = 'Customer login form';
      break;
    }
    case 'customerTelephoneService': {
      stateKeyMap = 'Telephone number';
      break;
    }
    case 'agodaBrandLink': {
      stateKeyMap = 'Agoda Brand link';
      break;
    }
    case 'pricelineBrandLink': {
      stateKeyMap = 'Priceline Brand link';
      break;
    }
    case 'telephoneNumber': {
      stateKeyMap = 'Service Number';
      break;
    }
  }
  return stateKeyMap;
};

export const stateMapping = (state: boolean) => {
  if (state) {
    return 'ON';
  } else {
    return 'OFF';
  }
};

export const checkStateChangeHandler = (
  prevState: IPrevAdminToolSettingsState,
  nextState: IPrevAdminToolSettingsState
) => {
  let updateFlag = false;
  let key: keyof typeof prevState;
  for (key in prevState) {
    if (prevState[key] !== nextState[key]) {
      updateFlag = true;
      break;
    }
  }
  return updateFlag;
};

export const buttonTextMap = (flag: boolean) => {
  if (flag) {
    return 'Save changes';
  } else {
    return 'Activate Crisis Tool';
  }
};

export const adminToolContentMapping = (flag: boolean) => {
  if (flag) {
    return 'The Crisis Tool is currently active. To disable it now, click here:';
  } else {
    return 'In the event of a major outage, traffic will be redirected via DNS to a static splash page. When the Crisis Tool is ready to handle guest/partner enquiries, you can access the options for it here:';
  }
};

export const truncate = (string: string, limit: number) => {
  if (string.length <= limit) {
    return string;
  } else {
    return string.slice(0, limit) + '...';
  }
};
